export class TreatmentCarouselModule {

    constructor() {
        this.init();
    }

    getCurrentIndex() {
        return parseInt($('.slick-current').attr('data-slick-index'), 10) + 1;
    }
    LoadCarousel() {
        $('.treatment-carousel').slick({
            dots: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 6000,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    init() {
        var that = this;
        that.getCurrentIndex();
        that.LoadCarousel();
    }

}